import { useState, useEffect, useRef } from "react";
import type { ReactNode } from "react";
import cx from "classnames";

import { Label } from "common/ui/Label";
import { Icon } from "common/ui/Icon";
import { ActionList } from "common/ui/ActionList";
import { Skeleton } from "common/ui/Skeleton";
import { Heading } from "common/ui/Heading";

import { useClickOutside } from "common/middleware/hooks";

import styles from "./DropdownMenu.module.scss";

interface Props {
  selected: { id?: string | number, item: ReactNode },
  items: {
    id: string | number,
    name: string | number,
    onClick: () => void,
  }[],
  isHeading?: boolean,
  alignRight?: boolean,
  alignLeft?: boolean,
  top?: boolean,
}

export function DropdownMenu({
  selected,
  items,
  isHeading = false,
  alignRight,
  alignLeft,
  top,
}: Props) {
  const [isOpen, setIsOpen] = useState(false);

  const dropdown = useRef(null);

  useClickOutside(dropdown, () => setIsOpen(false));

  useEffect(() => {
    setIsOpen(false);
  }, [selected]);

  const list = items.filter((i) => i.id !== selected?.id);

  return (
    selected && items ? (
      <div ref={dropdown} className={styles.DropdownMenu}>
        <div
          className={styles.Title}
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          {typeof selected.item === "string"
            ? isHeading
              ? <Heading variant="h2">{selected.item}</Heading>
              : <Label variant="l1">{selected.item}</Label>
            : selected.item
          }
          <Icon icon="moreActionsMinor" />
        </div>
        <div className={cx(styles.List, {
          [styles.open]: isOpen,
          [styles.alignRight]: alignRight,
          [styles.alignLeft]: alignLeft,
          [styles.top]: top,
        })}>
          <ActionList menu={list} />
        </div>
      </div>
    ) : (
      <Skeleton height={24} width={120} />
    )
  )
}

